import { FadeUp, Overline, MaskedLines } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { goToAnchor } from "@/lib/scroll";
import { FAQS } from "@/data/site";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-28 md:py-40 bg-charcoal/40 border-y hairline">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12">
        <FadeUp>
          <Overline>Questions</Overline>
        </FadeUp>
        <h2 className="mt-8 mb-14 font-display font-light text-4xl md:text-5xl lg:text-6xl leading-[0.98] tracking-tight">
          <MaskedLines lines={["FREQUENTLY ASKED."]} />
        </h2>

        <FadeUp delay={0.15}>
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b hairline">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="text-left font-display font-light text-lg md:text-2xl text-ivory/90 hover:text-gold hover:no-underline py-6 transition-colors duration-300"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-muted font-light leading-relaxed max-w-3xl pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>

        <FadeUp delay={0.25} className="mt-12 flex items-center justify-center gap-4 text-center">
          <span className="text-sm text-muted font-light">No answer found?</span>
          <button
            data-testid="faq-contact-link"
            onClick={() => goToAnchor("#contact")}
            className="text-[11px] uppercase tracking-[0.3em] text-bronze hover:text-gold transition-colors duration-300 border-b border-bronze/40 pb-1"
          >
            Contact Us
          </button>
        </FadeUp>
      </div>
    </section>
  );
}
